import React from 'react'
import AboutUsBanner from '../Components/About/AboutUsBanner';
import AboutWhyChooseUs from '../Components/About/AboutWhyChooseUs';
import Aboutarea from '../Components/About/Aboutarea';
import AboutHowWork from '../Components/About/AboutHowWork';
import AboutStatic from '../Components/About/AboutStatic';
import AboutTestimonial from '../Components/About/AboutTestimonial';

function AboutUs() {
    return (
        <>
            <AboutUsBanner />
            <AboutWhyChooseUs />
            <Aboutarea />
            <AboutHowWork />
            <AboutStatic />
            <AboutTestimonial />
        </>
    )
}

export default AboutUs
